/**
 * @desc ToB客户信息-分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.BusinessCustomerPageListResponseDto>
>;
export function request(
  params: API.basics.businessCustomer.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
